import { createAction } from 'redux-actions'

export const firebaseNoteAdded = createAction('FIREBASE_NOTE_ADDED')
export const firebaseNoteUpdated = createAction('FIREBASE_NOTE_UPDATED')
export const firebaseNoteDeleted = createAction('FIREBASE_NOTE_DELETED')
export const addNote = createAction('ADD_NOTE')
export const deleteNote = createAction('DELETE_NOTE')
export const decryptNotesSuccess = createAction('DECRYPT_NOTES_SUCCESS')
export const decryptNotesError = createAction('DECRYPT_NOTES_ERROR')



// WEBPACK FOOTER //
// ./src/services/notes/actions.js